export const IMAGE_EDITOR_SHOW  = 'IMAGE_EDITOR_SHOW';
export const IMAGE_EDITOR_HIDE  = 'IMAGE_EDITOR_HIDE';
export const IMAGE_EDITOR_SET_IMAGE  = 'IMAGE_EDITOR_SET_IMAGE';